{{#each links}}
<li class="{{#if disabled}}disabled {{/if}}">
	<a {{#if action}}data-action="{{action}}" {{/if}}{{#if disabled}}onClick="return false"{{/if}} {{#if id}}data-id="{{id}}" {{/if}}class="{{#unless disabled}}{{#if class}}{{class}} {{/if}}js-link{{/unless}}" href="{{link}}"> <i class="p-r-10 {{icon}}"></i>{{name}}</a>
</li>
{{/each}}
